import RestApi from '@/core/services/RestApi'

export default {
  data() {
    return {
      keyTypeOptions: []
    }
  },

  computed: {
    allowedKeyTypeOptions() {
      return this.keyTypeOptions.filter(opt => opt.allowed)
    },

    defaultKeyType() {
      const defaultOption =
        this.keyTypeOptions.find(opt => opt.default && opt.allowed) ||
        this.keyTypeOptions.find(opt => opt.allowed)
      return defaultOption ? defaultOption.value : ''
    }
  },

  methods: {
    fetchKeyTypes() {
      return RestApi.get(
        `projects/${this.$store.getters.projectId}/ssh-keys/key-types`
      ).then(({ data }) => {
        this.keyTypeOptions = data
        return data
      })
    },

    getKeyTypeLabel(value) {
      if (!value) return ''
      const lowerValue = value.toLowerCase()
      const option = this.keyTypeOptions.find(
        opt => opt.value.toLowerCase() === lowerValue
      )
      return option ? option.label : value
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/sshKeyTypesMixin.js